import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCases, createCase, approveCaseLocal, closeCase } from '../../services/cases';
import DataTable from '../../components/Tables/DataTable';
import Modal from '../../components/Common/Modal';
import Input from '../../components/Forms/Input';
import Select from '../../components/Forms/Select';
import { useForm } from 'react-hook-form';
import Toast from '../../components/Common/Toast';

const Cases = () => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState(null);
  const { control, handleSubmit, reset } = useForm();

  useEffect(() => {
    loadCases();
  }, []);

  const loadCases = async () => {
    try {
      const data = await getCases();
      setCases(data);
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load cases' });
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      await createCase(data);
      setToast({ type: 'success', message: 'Case created' });
      setShowModal(false);
      reset();
      loadCases();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const handleAction = async (id, action) => {
    try {
      if (action === 'approve') await approveCaseLocal(id);
      else if (action === 'close') await closeCase(id);
      loadCases();
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const renderActions = (row) => {
    switch (row.status) {
      case 'draft':
        return <button onClick={() => handleAction(row.id, 'approve')}>Submit for Approval</button>;
      case 'open':
        return <button onClick={() => handleAction(row.id, 'close')}>Close Case</button>;
      default:
        return null;
    }
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'type', label: 'Type' },
    { key: 'target_amount', label: 'Target (KSh)' },
    { key: 'status', label: 'Status' },
    { key: 'member.full_name', label: 'Member' },
    { key: 'actions', label: 'Actions', render: (_, row) => renderActions(row) },
  ];

  return (
    <div>
      <h1>Unit Cases</h1>
      <button onClick={() => setShowModal(true)}>Create New Case</button>
      <DataTable columns={columns} data={cases} loading={loading} />

      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Create Case">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Select
            name="member_id"
            control={control}
            label="Member"
            options={[]} // You would fetch members list for dropdown
            rules={{ required: true }}
          />
          <Select
            name="type"
            control={control}
            label="Case Type"
            options={[
              { value: 'welfare', label: 'Welfare' },
              { value: 'education', label: 'Education' },
              { value: 'medical', label: 'Medical' },
              { value: 'funeral', label: 'Funeral' },
            ]}
            rules={{ required: true }}
          />
          <Input name="target_amount" control={control} label="Target Amount" type="number" rules={{ required: true }} />
          <button type="submit">Create</button>
        </form>
      </Modal>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default Cases;